import { Grid, Card, CardActionArea, CardMedia, List, ListItem } from '@material-ui/core';

import styled from 'styled-components';

import { fontFamily, mediaQueries, getColorHeader } from '../../../../../../../libs';

export const SearchContainer = styled(Grid)`
  position: absolute;
  z-index: 13 !important;
  padding: 5px;
  background: #fff;
  max-width: 680px;
  min-height: 60px;
  width: 90% !important;
  top: 90%;
  border-radius: 5px;
  box-shadow: 1px 2px 5px 2px #00000040;

  * {
    font-family: ${fontFamily};
  }
`;

export const ListSuggestions = styled(List)`
  padding: 5px !important;
  width: 100% !important;

  @media (max-width: ${mediaQueries.mdDefault}px) {
    display: flex;
    flex-direction: row !important;
    flex-wrap: wrap !important;

    li {
      padding: 2.5px 5px !important;
    }
  }
`;

export const ListItemSuggestions = styled(ListItem)`
  padding: 5px !important;
  font-size: 13px;
  width: fit-content !important;
  max-width: 100% !important;
  font-family: ${fontFamily} !important;
`;

export const ProductTags = styled(Grid)`
  height: 35px !important;
`;

export const SearchTitle = styled.h2`
  font-size: 13px;
  font-weight: bold;
  padding: 0 10px;
  width: 100%;
  margin: 5px 0;
`;

export const CardStyled = styled(Card)`
  margin: 5px !important;
  height: fit-content !important;
  max-height: 300px;
  width: 145px;

  @media (max-width: ${mediaQueries.mdDefault}px) {
    width: 100%;
    button {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    * {
      font-size: 13px !important;
    }
  }
`;

export const CardActionAreaStyled = styled(CardActionArea)`
  padding: 5px !important;
`;

export const CardMediaStyled = styled(CardMedia)`
  height: 100px !important;
  display: flex !important;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 50px;
    color: #e8e8e8;
    margin: auto;
  }

  @media (max-width: ${mediaQueries.mdDefault}px) {
    height: 60px !important;
    width: 70px !important;
    margin: 0 5px !important;
  }
`;

export const ProductName = styled.div`
  flex: 1;
  height: 35px;
  font-size: 13px;
  margin: 5px 0;
  overflow: hidden;
  text-transform: lowercase;
  &::first-letter {
    text-transform: uppercase;
  }

  @media (max-width: ${mediaQueries.mdDefault}px) {
    margin: 0;
    height: 50px;
  }
`;

export const ProductId = styled.div`
  font-size: 13px;
  color: #8b8b8b;
`;

export const CardLink = styled.a`
  text-decoration: none !important;
  &:hover {
    color: unset !important;
  }
`;

export const ProductDiscount = styled.span`
  font-weight: bold;
  right: 5px;
  height: fit-content;
  width: fit-content;
  position: absolute;
  padding: 3px;
  font-size: 13px !important;
  background: ${getColorHeader};
  color: #ffffff !important;
  border-radius: 3px;
  text-align: center;
  line-height: 11px;

  @media (max-width: ${mediaQueries.mdDefault}px) {
    left: 5px;
    top: 0;
    font-size: 13px !important;
    padding: 2px;
  }
`;

export const ProducInfoContainer = styled(Grid)`
  @media (max-width: ${mediaQueries.mdDefault}px) {
    width: 100px !important;
    align-items: flex-end;
    span {
      width: fit-content;
    }
  }
`;

export const ProductInfo = styled.span`
  color: ${({ color }) => color} !important;
  font-weight: ${({ bold }) => (bold ? 'bold' : '')};
  text-decoration: ${({ linethroung }) => (linethroung ? 'line-through' : '')} !important;
  overflow: hidden;
  font-size: 13px;
  height: 20px;
`;

export const GridButton = styled(Grid)`
  padding-top: 10px !important;
`;

export const CardsContainer = styled(Grid)`
  @media (max-width: ${mediaQueries.mdDefault}px) {
    justify-content: center !important;
  }
`;

export const ProductPrice = styled.div`
  color: ${({ color }) => color} !important;
  font-weight: ${({ bold }) => (bold ? 'bold' : '')};
  text-decoration: ${({ lineThroung }) => (lineThroung ? 'line-through' : '')} !important;
  height: fit-content;
  overflow: hidden;
  font-size: 13px;
`;

export const Tag = styled.span`
  font-size: 13px;
  padding: 1px;
  margin: 0 2px 2px 0;
  height: fit-content;
  background: ${({ background }) => background}!important;
  color: ${({ color }) => color} !important;
  text-decoration: none !important;
  border-radius: 3px;
  text-decoration: none !important;
`;

export const ProductPricesContainer = styled(Grid)`
  height: 40px !important;
`;

export const Link = styled.a`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

export default {};
